export default __webpack_public_path__ + "static/media/uploader-roche-3.01915304.png";